











import { Box, Flex, AltInputLabel } from '../../atoms'
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {
    Box,
    Flex,
    AltInputLabel
  }
})
export default class ConsentBox extends Vue {
  get consentURL() {
    return (process?.env?.VUE_APP_FINNO_ENDPOINT || 'https://www.finnomena.com') + '/consent/settings'
  }
}
